import { api } from "../ApiState";
import { IApiResponse } from "../../Types/ApiResponse.model";

export const marketingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMarketingSubUsers: builder.query<
      IApiResponse<any>,
      { id: number; search?: object; page?: number; deleted?: boolean }
    >({
      query: ({ id, search, page, deleted }) => ({
        url: `marketing/sub-user-list/${id}`,
        method: "GET",
        params: {
          ...(search && { search: JSON.stringify({ ...search }) }),
          ...(page && { page }),
          ...(deleted && { deleted }),
        },
      }),
    }),

    getMarketingInfo: builder.query<any, number>({
      query: (id) => ({
        url: `marketing/status/${id}`,
        method: "GET",
      }),
    }),

    getSubUserTurnover: builder.query<
      IApiResponse<any>,
      { id: number; search?: object; page?: number; deleted?: boolean }
    >({
      query: ({ id, search, page, deleted }) => ({
        url: `marketing/sub-user-trans/${id}`,
        method: "GET",
        params: {
          ...(search && { search: JSON.stringify({ ...search }) }),
          ...(page && { page }),
          ...(deleted && { deleted }),
        },
      }),
    }),
  }),
});

export const {
  useGetMarketingSubUsersQuery,
  useGetMarketingInfoQuery,
  useGetSubUserTurnoverQuery,
} = marketingApi;

export default marketingApi;
